@if (resultsPlayerInfo) {
    <ds-card
        class="results-prizes-block info-block"
        [ngClass]="{ 'achieved-footer': isSinglePrize }"
        [elevated]="dsComponents?.dsCardStatic?.elevated"
        [variant]="dsComponents?.dsCardStatic?.variant">
        <div class="results-prizes-block-images">
            <img class="results-prizes-cup" [attr.src]="resultsPlayerInfo.headerImage?.src" />
        </div>
        <div class="results-prizes-block-content">
            <div class="results-info-title">{{ resultsPlayerInfo.title }}</div>
            <div class="results-info-value">{{ resultsPlayerInfo.description }}</div>
        </div>
    </ds-card>
}
